import { render } from "./ShowTemplateMainRep.vue?vue&type=template&id=87d4c898"
import script from "./ShowTemplateMainRep.vue?vue&type=script&lang=js"
export * from "./ShowTemplateMainRep.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/views/agro_exporter/quality_reports/process_by_main_rep/show_template_main_rep.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fviews%2Fagro_exporter%2Fquality_reports%2Fprocess_by_main_rep%2FShowTemplateMainRep.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__